import { gridByIdSelector } from "../gridByIdSelector";
import { RootState } from "@/store/store";

export const selectedResourceIdsByMasterIdSelector = (
  state: RootState,
  gridId: string,
): string[] | undefined => {
  const grid = gridByIdSelector(state, gridId);

  const allResourcesSelections = Object.values(grid?.selection ?? {});

  return allResourcesSelections
    .map((selection) => Object.values(selection))
    .flat(Infinity) as string[];
};
